import { TabPanel, TabView } from 'primereact/tabview';
import React from 'react';

import { GoalReview } from './goalReview/GoalReview';
import { GoalSetting } from './goalSetting/GoalSetting';
import { GoalExpansionTemplateProps } from './types';

export const GoalExpansionTemplate = (props: GoalExpansionTemplateProps) => {
    return (
        <TabView>
            <TabPanel header="Goal Setting">
                <GoalSetting
                    data={props.data}
                    handleCancel={props.handleCancel}
                    setViewState={props.setViewState}
                    receiverId={props.receiverId}
                    receiverName={props.receiverName}
                    goalId={props?.goalId}
                />
            </TabPanel>
            <TabPanel header="Month-End Review" disabled={!props.data.goal_locked}>
                <GoalReview
                    data={props.data}
                    handleCancel={props.handleCancel}
                    setViewState={props.setViewState}
                    receiverId={props.receiverId}
                    receiverName={props.receiverName}
                    goalId={props?.goalId}
                />
            </TabPanel>
        </TabView>
    );
};
